import { Button, ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import Link from "next/link";
import { useForm } from "react-hook-form";
import * as y from "yup";
import ErrorMessage from "./Parts/ErrorMessage";
import { PasswordField, TextField } from "./Parts/index";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const schema = y.object().shape({
  loginid: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。"),
  password: y.string().required("パスワードが入力されていません。")
});

// TODO: CSRFトークン
export default function LoginForm(props) {
  var _errors$loginid, _errors$password;
  const {
    onSubmit,
    error
  } = props;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isDirty,
    isValid,
    isSubmitting
  } = formState;
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: /*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: `${processStyles.content} ${loginStyles.loginSet}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${loginStyles.section} ${loginStyles.formSection}`,
          children: [/*#__PURE__*/_jsx("h3", {
            className: loginStyles.sectionTitle,
            children: "SPOOX ID\u3067\u30ED\u30B0\u30A4\u30F3"
          }), /*#__PURE__*/_jsxs("div", {
            className: loginStyles.sectionInner,
            children: [error && /*#__PURE__*/_jsx(ErrorMessage, {
              msg: error.message
            }), /*#__PURE__*/_jsx("fieldset", {
              children: /*#__PURE__*/_jsx(TextField, {
                ref: register,
                title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
                type: "email",
                name: "loginid",
                placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
                error: (_errors$loginid = errors.loginid) === null || _errors$loginid === void 0 ? void 0 : _errors$loginid.message
              })
            }), /*#__PURE__*/_jsxs("fieldset", {
              className: loginStyles.passwordFieldset,
              children: [/*#__PURE__*/_jsx(PasswordField, {
                ref: register,
                name: "password",
                title: "\u30D1\u30B9\u30EF\u30FC\u30C9",
                placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
                error: (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.message
              }), /*#__PURE__*/_jsxs("p", {
                className: formStyles.formInputInfo,
                children: ["\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u306F\u3001", /*#__PURE__*/_jsx(Link, {
                  href: routes.passwordRemind,
                  className: "mainColor",
                  children: "\u3053\u3061\u3089"
                }), "\u304B\u3089\u30EA\u30BB\u30C3\u30C8\u3067\u304D\u307E\u3059\u3002"]
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: loginStyles.loginBtnArea,
              children: /*#__PURE__*/_jsx(Button, {
                type: "submit",
                fillMainColor: true,
                large: true,
                fontFixed: true,
                disabled: !isDirty || !isValid,
                loading: isSubmitting,
                children: "SPOOX ID\u3067\u30ED\u30B0\u30A4\u30F3"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: loginStyles.toSignup,
              children: /*#__PURE__*/_jsxs("p", {
                children: ["\u4F1A\u54E1\u767B\u9332\u304C\u307E\u3060\u306E\u65B9\u306F", /*#__PURE__*/_jsx(Link, {
                  href: routes.signUp,
                  className: "mainColor",
                  children: "\u3053\u3061\u3089"
                }), "\u304B\u3089"]
              })
            })]
          })]
        })
      })
    })
  });
}